import { render, staticRenderFns } from "./Test24.vue?vue&type=template&id=780ef459&"
import script from "./Test24.vue?vue&type=script&lang=js&"
export * from "./Test24.vue?vue&type=script&lang=js&"
import style0 from "./Test24.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports